import styled from 'styled-components'
import { useDrop } from 'hooks'
import { useEffect } from 'react'

import { ButtonText } from './Button'

const Container = styled.div`
${({ theme: { button: { main }, colors } }) => `
  margin: 1px;
  padding: 1rem;
  background: ${colors('chrome')};
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: stretch;
  border-radius: ${main.radius};
  position: relative;
`}
`

const DropLabel = styled.p`
  font-size: 0.8rem;
  margin: 1rem 0 -0.5rem;
`

const FileOpen = styled.input`
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  & + label {
    ${({
      themeColor,
      disabled,
      theme: {
        button: { main },
        colors
      }
    }) => `
      cursor: pointer;
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0.35rem 1rem;
      border: 1px solid transparent;
      border-radius: ${main.radius};
      outline: none;
      background-color: ${main.background.default};
      box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.043);
      &:hover{
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
      }
      &:active{
        border: 1px solid ${colors('link')};
        box-shadow: 0px 0px 10px ${colors('link', 0.5)};
      }

      ${
        disabled
          ? `
              background-color: ${main.background.disabled};
              border: 1px solid ${main.border.disabled};
              ${ButtonText}{
                color: ${main.text.disabled};
                svg{
                  fill: ${main.text.disabled};
                }
              }
              &:hover{
                background-color: ${colors('foreground', 0.05)};
              }
              &.link {
                background: none;
                border: 0 none;
                box-shadow: none;
                ${ButtonText}{
                  color: ${colors('background')};
                }
              }
              `
          : `
              &.link {
              background: none;
              color: ${colors('link')};
              box-shadow: none;
              }
              `
      }

      ${themeColor ? `background-color: ${colors(themeColor)};` : ''}
    `}
    ${({ theme: { colors } }) => `
      color: ${colors('text')};
      font-size: 0.8rem;
    `}
`

export const DragTargetBoundry = styled.div`
  ${({ theme: { colors } }) => `
    border: 2px dashed ${colors('text', 0.25)};
    border-radius: 0.5rem;
    margin: 1px;
    padding: 2rem;
    background: ${colors('chrome')};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    &.dragging {
      border: 2px dashed ${colors('link')};
    }
  `}
`

const FileOpenButton = ({
  text = 'Choose a file',
  name,
  onChange = console.log
}) => {
  const handleChange = (ev) => {
    const { files, name, result } = ev.target
    const value = []
    for (let i = 0; i < files.length; i++) {
      const file = files.item(i)
      value.push(file)
    }
    onChange({ target: { name, files: value } })
  }

  return (
    <>
      <FileOpen
        data-testid={`${name}_file_input`}
        id={name}
        name={name}
        onChange={handleChange}
        type="file"
      />
      <label htmlFor={name}>{text}</label>
    </>
  )
}

export const DragTarget = ({ children, name, onChange = () => true }) => {
  const { dragOver, dropRef, items } = useDrop()

  useEffect(() => {
    onChange({ target: { name, files: items } })
  }, [items])

  return (
    <DragTargetBoundry
      className={dragOver ? 'dragging' : null}
      ref={dropRef}
      data-testid={`${name}_drag_target`}
    >
      {children}
    </DragTargetBoundry>
  )
}

export const FileUpload = ({
  buttonLabel,
  label,
  name,
  onChange = console.log
}) => {
  return (
    <Container>
      <DragTarget name={name} onChange={onChange}>
        <FileOpenButton name={name} onChange={onChange} text={buttonLabel} />
        <DropLabel>{label}</DropLabel>
      </DragTarget>
    </Container>
  )
}
